import AcmIssueContainer from 'views/pages/acm-issue/AcmIssueContainer';

export default AcmIssueContainer;
